import React from 'react';
import { motion } from 'framer-motion';
import { TrustBadges } from './TrustBadges';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface CTAButtonProps {
  text: string;
  microcopy?: string;
  href?: string;
  className?: string;
  icon?: ReactNode;
}
export function CTAButton({
  text,
  microcopy,
  href = '#pricing',
  className = '',
  icon
}: CTAButtonProps) {
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  };
  return <div className={`flex flex-col items-center justify-center w-full ${className}`} data-id="element-82">
      <motion.a href={href} onClick={handleClick} animate={{
      boxShadow: ['0px 0px 0px rgba(196,30,58,0)', '0px 0px 20px rgba(196,30,58,0.6)', '0px 0px 0px rgba(196,30,58,0)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} className="relative overflow-hidden flex items-center justify-center gap-3 w-full max-w-md text-center bg-gradient-to-r from-[#C41E3A] to-[#8B2252] text-white font-body font-bold text-lg md:text-xl py-4 px-8 rounded-full transition-all duration-300 group" data-id="element-83">
        {/* Shimmer effect */}
        <motion.div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" animate={{
        translateX: ['-100%', '200%']
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'linear',
        repeatDelay: 1
      }} data-id="element-84" />

        <div className="relative z-10 flex items-center justify-center gap-3" data-id="element-85">
          {icon && <span className="flex-shrink-0" data-id="element-86">{icon}</span>}
          <span data-id="element-87">{text}</span>
        </div>
      </motion.a>
      {microcopy && <p className="mt-3 text-sm text-mutedBrown font-body text-center max-w-md opacity-90" data-id="element-88">
          {microcopy}
        </p>}
      <TrustBadges data-id="element-89" />
    </div>;
}